import {
    List,
} from '@mui/material';

import MenuListItem from './menu-item';
import navItems from '../../../services/menu-service';
import { AppPermissionsContext } from '../app-context/app-permission-context';

import React, {
    useContext
} from 'react';

const GetMenuListItem = (permissions) => {
    return navItems(permissions).map(f => {
        if (f.visible) {
            return <MenuListItem key={f.route} {...f}></MenuListItem>
        }
        return;
    });
}

const MenuList = () => {
    const { permissions } = useContext(AppPermissionsContext);
    const [expandedMenu, setExpandedMenu] = React.useState(null);

    const handleExpand = (title) => {
        setExpandedMenu(expandedMenu === title ? null : title);
    };

    return (
        <List sx={{ padding: '9px' }}>
            {navItems(permissions).map(item => {
                if (item.visible) {
                    return (
                        <MenuListItem
                            key={item.title}
                            {...item}
                            expanded={expandedMenu === item.title}
                            onExpand={() => handleExpand(item.title)}
                        />
                    );
                }
                return null;
            })}
        </List>
    );
};

export default MenuList;